import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Inject,
  Input,
  OnInit,
} from '@angular/core';
import { QueryParamsHandling } from '@angular/router';
import { IconRegistryService } from '@rd/core/services/icon-registry/icon-registry.service';
import { IS_WEBVIEW } from '@rd/core/tokens/rd-lib.token';
import { DisplayMode } from '@rd/types';

type componentRenderState = 'loading' | 'content';

@Component({
  selector: 'rd-shared-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BreadcrumbComponent implements OnInit {
  @HostBinding('class.rd-shared-breadcrumb') componentClass = true;
  @HostBinding('class.stacked-desktop') get isStackedDesktop(): boolean {
    return this.displayModeDesktop === 'stacked';
  }
  @HostBinding('class.embedded-desktop') get isEmbeddedDesktop(): boolean {
    return this.displayModeDesktop === 'embedded';
  }
  @HostBinding('class.stacked-mobile') get isStackedMobile(): boolean {
    return this.displayModeMobile === 'stacked';
  }
  @HostBinding('class.embedded-mobile') get isEmbeddedMobile(): boolean {
    return this.displayModeMobile === 'embedded';
  }

  @Input() displayModeDesktop: DisplayMode;
  @Input() displayModeMobile: DisplayMode;
  @Input() breadcrumbText: string;
  @Input() loading: boolean;
  @Input() redirectURL: string;
  @Input() queryParams: any;
  @Input() queryParamsHandling: QueryParamsHandling = '';

  shouldDisplayBreadcrumb: boolean;
  private defaultDisplayMode: { desktop: DisplayMode; mobile: DisplayMode } = {
    desktop: 'stacked',
    mobile: 'embedded',
  };

  constructor(
    private iconRegistryService: IconRegistryService,
    @Inject(IS_WEBVIEW) protected isWebview: boolean,
  ) {
    this.shouldDisplayBreadcrumb = !isWebview;

    this.displayModeDesktop =
      this.displayModeDesktop ?? this.defaultDisplayMode.desktop;
    this.displayModeMobile =
      this.displayModeMobile ?? this.defaultDisplayMode.mobile;
  }

  ngOnInit(): void {
    this.registerIcons();
  }

  componentRenderState(): componentRenderState {
    if (this.loading) {
      return 'loading';
    } else {
      return 'content';
    }
  }

  private registerIcons(): void {
    this.iconRegistryService.registerIcon('back');
  }
}
